import React from 'react';
export class CnListProItemExtra extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}
CnListProItemExtra.displayName = 'CnListProItemExtra';
